export default __webpack_public_path__ + "static/dropdownDapp-a43e634b059668ed50cc2addab20246b.png";